/**
 * Formats a facet product count for display next to a filter option.
 * Counts under 1,000 are shown as-is; counts of 1,000 or more are abbreviated with "K+"
 * (e.g. 1,245 => 1K+). Returns an empty string when no count is available.
 * @param {number|null|undefined} count
 * @returns {string}
 */
export const formatFacetCount = (count) => {
    if (count === null || count === undefined || Number.isNaN(Number(count))) {
        return '';
    }

    const value = Number(count);
    if (value < 1000) {
        return String(value);
    }

    return `${Math.floor(value / 1000)}K+`;
};

export default formatFacetCount;
